import { vnModule_knockoutJS } from '../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS';
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from '../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler';
import { header } from './header';
import { vn_app_zone_notification } from '../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification';
import { websiteUsersImport_template } from '../components/templates/websiteUsersImport_template';

declare var ko: any;
declare var page: any;

export class website_users_import extends vnModule_knockoutJS {

    protected XHRHdl: XMLHttpRequestHandler;
    public websiteUsersImport: websiteUsersImport_template;

    protected getModuleName(){

        return 'website_users_import';
    }

    buildContent() : Array<Element> {
        
        this.websiteUsersImport = new websiteUsersImport_template('websiteUsersImport_template', this.viewModel, this);
        let zoneHeader = this.getVnAppZone().app.getZoneByName('Header');
        let loadedModule = zoneHeader!.loadedModule;
        (<header>loadedModule).setHeaderTitle('Import Newsletter Subscriptions');

        this.getVnAppZone().app.params.idBrand;

        return [this.websiteUsersImport.build()];
    }

    public fillPage(): void {

        this.getReferences();
    }

    protected getReferences() {

        // LOADING : starts
        this.loadingIn(this.websiteUsersImport.builtTemplate);

        let usrReq_url: string = '/api/website-users/references';
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onReferencesRequestReturn;
        this.XHRHdl.execute();
    }

    public onReferencesRequestReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                obj.loadingOut(obj.websiteUsersImport.builtTemplate);

                //check if user has article write permissions
                let responseParsed = JSON.parse(req.request.response);
                obj.websiteUsersImport.setBrands(responseParsed.brands)
                obj.websiteUsersImport.setMailingLists(responseParsed.mailingLists)
            })
        }
    }


    protected saveImport(type) {

        let formReq_url: string = '/api/website-users/import/';
        let data =  this.websiteUsersImport.getViewModelForRequest();

        var formData = new FormData();
        for (const key in data) {
            formData.append(key, data[key]);
        }
        formData.append('type', type);

        let request = [];
        let xhttp = new XMLHttpRequest();
        request["request"] = xhttp;

        // Set POST method and ajax file path
        xhttp.open("POST", formReq_url, true);

        // call on request changes state
        if(type == 'summary'){

            this.loadingIn(this.websiteUsersImport.builtTemplate);
            xhttp.onreadystatechange = this.onSummaryImportReturn(request, this);
        }else{

            this.loadingIn(document.getElementsByClassName('import-user-summary')[0]);
            xhttp.onreadystatechange = this.onSaveImportReturn(request, this);
        }

        // Send request
        xhttp.send(formData);
    }

    protected onSummaryImportReturn(req, obj) {

        return function () {

            obj.manageResponse(req, obj, function () {

                let response = JSON.parse(req.request.response);
                obj.websiteUsersImport.setSummary(response.data);
                obj.websiteUsersImport.toggleSummaryDialogVisibility();
            });
            
            obj.loadingOut(obj.websiteUsersImport.builtTemplate);
        }
    }
    
    protected onSaveImportReturn(req, obj) {

        return function () {

            obj.manageResponse(req, obj, function () {

                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, 'Successfully imported');
                obj.websiteUsersImport.setSummary([]);
                obj.websiteUsersImport.toggleSummaryDialogVisibility();
                obj.redirectToList();
            });
        }
    }

    protected redirectToList() {

        page('/website-users/');
    }

    protected filterDropdownOnChange(idElement) {

        this.websiteUsersImport.updateMailingList();
    }

    protected filterMultipleSelectorOnChange(idElement) {

    }
    
}



// WEBPACK FOOTER //
// ./js/modules/website_users_import.ts